import React, { useEffect } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { Typewriter } from 'react-simple-typewriter';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/hero.css'; // Your custom CSS
import myimage from '../images/mahesh.png';
import app_logo from '../images/playstore.png';
import { FaLinkedin, FaGithub,FaGoogle, FaMediumM, FaInstagram, FaArrowRight } from 'react-icons/fa';
import { Tooltip } from 'bootstrap';
import { SiLeetcode, SiHuggingface } from 'react-icons/si';

const HeroSection = () => {
  useEffect(() => {
    // Enable tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <section
      className="hero-section  d-flex flex-column align-items-center justify-content-center"
      style={{ backgroundColor: 'black' }}
    >
      <Container className="text-center">
        <Row className="align-items-center justify-content-center">
          {/* Left Side - Name and Description */}
          <Col md={6} xs={12} className="d-flex flex-column justify-content-center py-2 mt-md-0">
            <p className="small-text text-light" style={{ marginTop: '12px' }}>
              Hello Welcome.... <span role="img" aria-label="wave">🤚</span>
            </p>
            <h1 className="display-5 fw-bold"
              style={{
                background: 'linear-gradient(90deg, #00f260, #0575E6)',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
              }}>
              <span className='fs-4 fw-bold text-start' > I am </span> <br /> Bandaru Mahesh
            </h1>        
            <p class="fw-bold text-light text-end  " style={{fontSize:'0.9rem'}}> <FaArrowRight/> <small>Commitment to Excellence </small> </p>

            <h3 className='fs-4 fw-bold'>IIT Kharagpur </h3>
            <p className="mt-1 fw-bold" style={{ fontSize: '0.9rem', color: '#fff' }}>
            With a deep passion for Technology and Innovation, 
            I am skilled in AI & ML, Quantum Computing, Big Data, 
            Data Science & Analytics and Multi-Cloud Computing. My expertise spans diverse 
            fields such as Geophysical Exploration,Energy Sector, 
            Full Stack 3.0, Web & Mobile Applications Development, 
            and Blockchain Technology. I combine a strong technical 
            background with entrepreneurial vision to deliver cutting-edge 
            solutions and services across multiple industries, whether it's 
            creating scalable software, developing AI-driven products, or 
            working on complex cloud, Quantum-Micro and blockchain architectures.
            At OlewinTechSolutions, my mission is to empower businesses with advanced
            technology solutions that address modern challenges, helping them stay 
            competitive and future-ready. 
              
            </p>
            <div className="mt-2">
              {/* <Button variant="success" className="me-2 rounded-pill fw-bold " href="https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/resume%2FBANDARU%20MAHESH.pdf?alt=media&token=35a8d43b-ad76-4292-a7e8-6f42a3c6c0e6" target='_blank'  >Download Resume</Button> */}
              <Button variant="primary" className="me-2 rounded-pill fw-bold " href="https://olewintechsolutions.com" target="_blank"> Tech Company</Button>
              <Button variant="success" className="me-2 rounded-pill fw-bold " href="https://olewinacademy.com/" target='_blank'  >Academy Website</Button>
              <Button variant="light" className="me-2 rounded-pill fw-bold " href="https://olewinai.com/" target="_blank"> AI Product</Button>
            </div>
          </Col>
{/* access token for resume : - https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/resume%2FBANDARU%20MAHESH.pdf?alt=media&token=35a8d43b-ad76-4292-a7e8-6f42a3c6c0e6 */}
          {/* Right Side - Image and Typing Effect */}
          <Col md={6} xs={12} className="text-center">
            <div className="center-img-container mb-4">
              <Image src={myimage} alt="Profile" fluid className="center-img" />
            </div>
            <h3 className="mt-3 fw-bold fs-3"
              style={{
                background: 'linear-gradient(90deg, #00f260, #0575E6)',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
              }}>
              <Typewriter
                words={[
                  'AI & ML Engineer',
                  'Quantum Computing',
                  'Big Data Engineer',
                  'Geologist & Geophysicist',
                  'Data Scientist & Analyst',
                  'Full Stack 3.0 Developer',
                  'Mobile App Developer',
                  'AWS/Google - Cloud Engineer',
                  'YouTuber',
                ]}
                loop={0}
                cursor
                cursorStyle="|"
                cursorColor='white'
                typeSpeed={80}
                deleteSpeed={80}
                delaySpeed={1000}
              />
            </h3>

            {/* Social Icons with Tooltip */}
            <div className="d-flex justify-content-center py-3">
              <a href="https://www.linkedin.com/in/bandaru-mahesh-b1a12532a" target='_blank' rel="noreferrer" className="bg-primary text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="LinkedIn">
                <FaLinkedin size={25} />
              </a>
              <a href="https://github.com/olewintechsolutions" target='_blank'  rel="noreferrer" className="bg-dark text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="GitHub">
                <FaGithub size={25} />
              </a>
              <a href="https://leetcode.com/u/LEF5kPLxjG/" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="LeetCode">
                <SiLeetcode size={25} />
              </a>
                <a href="https://huggingface.co/bandarumahesh333" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="Hugging Face">
                <SiHuggingface size={25} />
              </a>
              <a href=" https://www.instagram.com/bandaru_mahesh333/" target='_blank' rel="noreferrer"  className="  text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Instagram">
                <FaInstagram size={25} />
              </a>
              {/* <a href="https://www.youtube.com/@OlewinAcademy" target='_blank' rel="noreferrer" className="bg-danger text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="YouTube">
                <FaYoutube size={25} />
              </a> */}
              <a href="mailto:bandarumahesh2024@gmail.com" target='_blank' rel="noreferrer" className=" bg-success text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Google">
                <FaGoogle size={25} />
              </a>
              <a href="https://bandarumahesh.medium.com/" target='_blank' rel="noreferrer"  className="text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Medium">
                <FaMediumM size={25} />
              </a>
              {/* <a href="https://twitter.com/@olewintech" target='_blank' rel="noreferrer"  className=" bg-info text-white mx-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Twitter/X">
                <FaTwitter size={25} />
              </a> */}
              
            </div>
            <div>
              <p className=' fw-bold text-warning me-2' > Download My App...
              </p>
                <p>
                <img src={app_logo} alt="app" className='img-fluid  ' style={{width:'150px', height: '50px'}}  />
                </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
